import { render } from "./Header.vue?vue&type=template&id=fa6fa5a4"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=fa6fa5a4&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__